import React, { useState } from "react";

const CHOICES = ["✊ Rock", "✋ Paper", "✌️ Scissors"];

export default function RockPaperScissors() {
  const [player, setPlayer] = useState(null);
  const [computer, setComputer] = useState(null);
  const [result, setResult] = useState("");

  const play = (choiceIndex) => {
    const compIndex = Math.floor(Math.random() * 3);
    setPlayer(CHOICES[choiceIndex]);
    setComputer(CHOICES[compIndex]);

    if (choiceIndex === compIndex) setResult("It's a Tie! 🤝");
    else if (
      (choiceIndex === 0 && compIndex === 2) ||
      (choiceIndex === 1 && compIndex === 0) ||
      (choiceIndex === 2 && compIndex === 1)
    )
      setResult("You Win! 🎉");
    else setResult("Computer Wins! 😭");
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center font-sans text-white text-center px-4">
      <h1 className="text-4xl font-bold mb-12">Rock, Paper, Scissors</h1>

      <div className="flex gap-4 mb-12">
        {CHOICES.map((choice, i) => (
          <button
            key={i}
            onClick={() => play(i)}
            className="px-6 py-4 bg-slate-800 hover:bg-indigo-600 rounded-2xl text-2xl transition shadow-lg"
          >
            {choice}
          </button>
        ))}
      </div>

      {player && (
        <div className="bg-slate-800 p-8 rounded-2xl w-full max-w-md animate-fade-in">
          <div className="flex justify-between text-xl font-bold mb-6">
            <div className="text-indigo-400">
              You
              <br />
              <span className="text-4xl">{player.split(" ")[0]}</span>
            </div>
            <div className="text-slate-400 mt-4">VS</div>
            <div className="text-red-400">
              Bot
              <br />
              <span className="text-4xl">{computer.split(" ")[0]}</span>
            </div>
          </div>
          <div className="text-2xl font-black text-yellow-400">{result}</div>
        </div>
      )}
    </div>
  );
}
